import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Edit = props => (
  <SvgIcon viewBox="0 0 12.034 12.035" {...props}>
    <g transform="translate(-6 -6.019)">
      <g transform="translate(14.798 16.665)">
        <path
          className="a"
          d="M44.463,53.389a.463.463,0,0,1,0-.926h0a.463.463,0,1,1,.926,0A.927.927,0,0,1,44.463,53.389Z"
          transform="translate(-44 -52)"
        />
      </g>
      <g transform="translate(15.261 12.123)">
        <path
          className="a"
          d="M46.463,37.853A.463.463,0,0,1,46,37.39V32.848a.463.463,0,1,1,.926,0V37.39A.463.463,0,0,1,46.463,37.853Z"
          transform="translate(-46 -32.385)"
        />
      </g>
      <g transform="translate(6.463 17.128)">
        <path
          className="a"
          d="M16.8,54.926H8.463a.463.463,0,1,1,0-.926H16.8a.463.463,0,0,1,0,.926Z"
          transform="translate(-8 -54)"
        />
      </g>
      <g transform="translate(6 16.665)">
        <path
          className="a"
          d="M6.926,53.389A.927.927,0,0,1,6,52.463a.463.463,0,1,1,.926,0h0a.463.463,0,1,1,0,.925Z"
          transform="translate(-6 -52)"
        />
      </g>
      <g transform="translate(6 8.33)">
        <path
          className="a"
          d="M6.463,25.261A.463.463,0,0,1,6,24.8V16.463a.463.463,0,1,1,.926,0V24.8A.463.463,0,0,1,6.463,25.261Z"
          transform="translate(-6 -16)"
        />
      </g>
      <g transform="translate(6 7.867)">
        <path
          className="a"
          d="M6.463,15.389A.463.463,0,0,1,6,14.926.927.927,0,0,1,6.926,14a.463.463,0,1,1,0,.926h0A.463.463,0,0,1,6.463,15.389Z"
          transform="translate(-6 -14)"
        />
      </g>
      <g transform="translate(6.463 7.867)">
        <path
          className="a"
          d="M13,14.926H8.463a.463.463,0,1,1,0-.926H13a.463.463,0,0,1,0,.926Z"
          transform="translate(-8 -14)"
        />
      </g>
      <g transform="translate(10.615 6.354)">
        <path
          className="a"
          d="M26.394,12.914a.463.463,0,0,1-.327-.79L30.589,7.6a.463.463,0,1,1,.655.655l-4.522,4.522A.461.461,0,0,1,26.394,12.914Z"
          transform="translate(-25.931 -7.465)"
        />
      </g>
      <g transform="translate(10.168 10.876)">
        <path
          className="a"
          d="M24.464,30.007a.453.453,0,0,1-.1-.01.463.463,0,0,1-.356-.55l.447-2.084a.463.463,0,0,1,.906.194l-.447,2.084A.463.463,0,0,1,24.464,30.007Z"
          transform="translate(-24 -26.997)"
        />
      </g>
      <g transform="translate(12.252 7.991)">
        <path
          className="a"
          d="M33.465,19.984a.463.463,0,0,1-.327-.79l4.522-4.522a.463.463,0,1,1,.655.655l-4.522,4.522A.461.461,0,0,1,33.465,19.984Z"
          transform="translate(-33.002 -14.535)"
        />
      </g>
      <g transform="translate(10.167 12.513)">
        <path
          className="a"
          d="M24.462,35.442a.463.463,0,0,1-.1-.916l2.084-.447a.463.463,0,1,1,.194.905l-2.084.447A.468.468,0,0,1,24.462,35.442Z"
          transform="translate(-23.999 -34.069)"
        />
      </g>
      <g transform="translate(14.319 7.172)">
        <path
          className="a"
          d="M44.029,13.563a.461.461,0,0,1-.327-.136l-1.637-1.637a.463.463,0,0,1,.655-.655l1.637,1.637a.463.463,0,0,1-.327.79Z"
          transform="translate(-41.929 -11)"
        />
      </g>
      <g transform="translate(15.137 6.019)">
        <path
          className="a"
          d="M47.563,8.917a.463.463,0,0,1-.328-.791.705.705,0,0,0,0-.982.722.722,0,0,0-.982,0,.463.463,0,1,1-.655-.655A1.621,1.621,0,0,1,47.89,8.781a.46.46,0,0,1-.327.135Z"
          transform="translate(-45.462 -6.019)"
        />
      </g>
    </g>
  </SvgIcon>
);

export default Edit;
